import { useNavigate } from 'react-router-dom';
import RoundedCard from './RoundedCard';
import type { ArtistType } from '../../types/ArtistType';
import RainbowHeartIcon from '../my-page-test-icon/RainbowHeartIcon';
import { formatDateToDot, getLikedMembersString } from '../utils/MyFanDomItemUtil';
import { useColorMode } from '@chakra-ui/react';

const MyFanDomItem = ({ artist }: { artist: ArtistType }) => {
  const { colorMode } = useColorMode();
  const navigate = useNavigate();

  const handleAddLikedArtist = () => {
    navigate('/artists/manage');
  };

  return (
    <li className="relative z-0 rounded-[20px] overflow-visible my-3 ml-[14px]">
      {/* Glow Layer */}
      <div
        className="absolute inset-0 z-[-1] rounded-[20px] blur-[7.5px]"
        style={glowLayerStyle[colorMode]}
      />

      {/* 실제 카드 */}
      <RoundedCard showShadow={false} onClick={handleAddLikedArtist}>
        <div className="flex p-4 gap-3 w-auto min-w-[225px]">
          <LikeDateBox artist={artist} />
          <div className="flex flex-col justify-center gap-[6px]">
            <LikedMembersText artist={artist} />
            <p className="text-main-light-2 font-semibold text-[15px] leading-none dark:text-main-dark-2">
              {artist.fandomName}
            </p>
          </div>
        </div>
      </RoundedCard>
    </li>
  );
};

const LikeDateBox = ({ artist }: { artist: ArtistType }) => {
  const { colorMode } = useColorMode();

  return (
    <div
      style={likeDateBoxColorStyle[colorMode].boxColorStyle}
      className="flex flex-col justify-center items-center w-[54px] h-[54px] gap-[3px] shrink-0 rounded-[14px]"
    >
      <p
        style={likeDateBoxColorStyle[colorMode].dPulsDayColorStyle}
        className="text-center font-semibold text-[12px] leading-normal tracking-tight"
      >{`D+${artist.likedDays}`}</p>
      <p
        style={likeDateBoxColorStyle[colorMode].dateColorStyle}
        className="text-center font-semibold text-[8px] leading-normal"
      >
        {formatDateToDot(artist.likedDate)}
      </p>
    </div>
  );
};

const LikedMembersText = ({ artist }: { artist: ArtistType }) => {
  const likedMembersString = getLikedMembersString(artist);
  return (
    <div className="flex items-center gap-[2px]">
      <p className="text-main-light-4 font-medium text-sm leading-none">{likedMembersString}</p>
      <RainbowHeartIcon />
    </div>
  );
};

export default MyFanDomItem;

const glowLayerStyle = {
  light: {
    background: `
      linear-gradient(0deg, rgba(255, 255, 255, 0.60), rgba(255, 255, 255, 0.60)),
      radial-gradient(50% 50% at 50% 50%, #FFF 0%, rgba(255, 255, 255, 0.00) 100%),
      conic-gradient(from 135deg at 50% 50%, #FFEFB5, #EAB0FA 102.6deg, #90ECFF 232.2deg, #FFEFB5 360deg)
    `
  },
  dark: {
    background: `
    linear-gradient(0deg, rgba(2, 2, 2, 0.68) 0%, rgba(2, 2, 2, 0.68) 100%),
    radial-gradient(50% 50% at 50% 50%, #000 0%, rgba(0, 0, 0, 0.00) 100%),
    conic-gradient(from 135deg at 50% 50%, #B8A055 0deg, #A871BB 102.6deg, #5BA3BB 232.2deg, #B8A055 360deg)
    `
  }
};

export const likeDateBoxColorStyle = {
  light: {
    boxColorStyle: {
      background: `linear-gradient(0deg, rgba(255, 255, 255, 0.68) 0%, rgba(255, 255, 255, 0.68) 100%), 
               radial-gradient(50% 50% at 50% 50%, #FFF 0%, rgba(255, 255, 255, 0.00) 100%), 
               conic-gradient(from 135deg at 50% 50%, #FFEFB5 0deg, #EAB0FA 102.6deg, #90ECFF 232.2deg, #FFEFB5 360deg)`
    },
    dPulsDayColorStyle: {
      background:
        'conic-gradient(from 135deg at 50% 50%, #E6D485 0deg, #C888E6 102.6deg, #5BC8FF 232.2deg, #E6D485 360deg)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent'
    },
    dateColorStyle: {
      color: 'rgba(135, 29, 173, 0.45)',
      letterSpacing: '-0.4px'
    }
  },
  dark: {
    boxColorStyle: {
      background: `
    linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%), 
    radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.00) 100%), 
    conic-gradient(from 135deg at 50% 50%, #E5B400 0deg, #CB3AF3 102.6deg, #03D3FF 232.2deg, #E5B400 360deg)
  `
    },
    dPulsDayColorStyle: {
      background:
        'conic-gradient(from 135deg at 50% 50%, #E5B400 0deg, #CB3AF3 102.6deg, #03D3FF 232.2deg, #E5B400 360deg)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent'
    },
    dateColorStyle: {
      color: 'rgba(222, 174, 239, 0.45)',
      letterSpacing: '-0.4px'
    }
  }
};